import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
  Masonry,
  Utils,
} from "arv-reactcomponents";
import { BRANDSLIST, pageType } from "npmlinks-constants";

import Analytics from "../../../analytics";
import { setPageType } from "../../../utils";
import Anchor from "../../../component/Anchor";
import BrandListFilter from "../BrandListFilter";
import BannerComponent from "../BannerComponent";
import BrandsListKeyContainer from "../BrandsListKeyContainer";

@inject("StaticPageStore", "CommonStore")
@observer
class BrandListComponent extends Component {
  static returnBrand(brand) {
    return (
      <div key={brand.key} id={brand.key} className="nw-brandslist-wrapper">
        <div className="nw-brandslist-listcontainer">
          <h2 className="nw-brandslist-brandkey">{brand.key}</h2>
          <ul className="nw-brandslist-list">
            {brand.value.map(data => (
              <li className="nw-brandslist-item" key={data.brandId}>
                <Anchor.component
                  className="nw-brandslist-anchoritems"
                  target="_blank"
                  href={
                    data.url
                      ? BRANDSLIST.HREF_SUFFIX.concat(data.url)
                      : data.productListingUrl
                  }
                  to={
                    data.url
                      ? BRANDSLIST.HREF_SUFFIX.concat(data.url)
                      : data.productListingUrl
                  }
                  key={data.brandId}
                >
                  {data.brandName}
                </Anchor.component>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      selectSelectedValue: "View All",
      query: "",
      showFilter: true,
      showBanner: true,
    };

    this.getSelectSelection = this.getSelectSelection.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.handleInputQuerySubmit = this.handleInputQuerySubmit.bind(this);
    this.brandBlock = this.brandBlock.bind(this);
  }

  componentDidMount() {
    const { isBrandJourney } = this.props;
    setPageType(pageType.brandslist);
    Analytics.pageView(window.pageType);
    if (isBrandJourney) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        showFilter: !this.state.showFilter,
        showBanner: !this.state.showBanner,
      });
    }
  }

  getSelectSelection(selectedValue) {
    this.setState({
      selectSelectedValue: selectedValue,
    });
    this.props.StaticPageStore.setFilterValue(selectedValue);
    this.masonryData.initialize();
  }

  updateQuery(value) {
    this.setState({ query: value });
    this.props.StaticPageStore.setSearchValue(value);
    this.masonryData.initialize();
  }

  handleInputQuerySubmit(value) {
    const { query } = this.state;
    if (!value) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: BRANDSLIST.INVALID_INPUT_ERR_MSG,
        timeout: 3000,
      });
    } else {
      this.props.StaticPageStore.setSearchValue(query);
      this.masonryData.initialize();
    }
  }

  brandBlock(key) {
    this.position = Utils.getBoundClientRect(document.getElementById(key));
    Utils.scrollTo(window, BRANDSLIST.SCROLL_X, this.position.top, 600);
  }

  get brandsListKey() {
    const brandObject = toJS(this.props.StaticPageStore.filteredBrandList);
    let keys;
    if (brandObject && brandObject.length) {
      keys = brandObject.map(item => (item.key && item.key) || "");
    }
    return keys;
  }

  render() {
    const { isDesktop } = this.props.CommonStore;
    const { selectSelectedValue, query, showBanner, showFilter } = this.state;
    const columnCount = BRANDSLIST.HOME_MASONRY_COLUMN_COUNT;
    const bannerObject = toJS(this.props.StaticPageStore.brandBannerObject);
    const trendingBannerObject = toJS(
      this.props.StaticPageStore.trendingBannerObject,
    );
    const filters = toJS(this.props.StaticPageStore.brandListFilter);
    const brandsListKeys = this.brandsListKey;
    const brandObject = toJS(this.props.StaticPageStore.filteredBrandList);
    return (
      <GridContainer className="nwc-main-content-wrapper">
        <GridRow className="nw-brandslist-headerhr">
          <GridColumn className="nw-brandslist-header">
            <div className="nw-brandlist-headertitle">
              {BRANDSLIST.BRANDSLIST_HEADER_TITLE}
            </div>
            <BrandListFilter.component
              gridClassName="nw-brandslist-selectcontainer"
              selectClassName="nw-brandslist-filterselect"
              filters={filters}
              selectSelectedValue={selectSelectedValue}
              setSelectedValue={this.getSelectSelection}
              query={query}
              formClassName="nw-brandslist-form"
              inputClassName="nw-brandslist-searchinput"
              buttonClassName="nw-brandslist-applybutton"
              handleInputQuery={this.updateQuery}
              handleInputQuerySubmit={this.handleInputQuerySubmit}
              showBrandTypeFilter={showFilter}
            />
          </GridColumn>
        </GridRow>
        <GridRow className="nwc-main-content-wrapper nw-brandslist-body">
          <GridColumn className="nwc-grid-col-xs">
            <GridRow className="nw-brandslist-masonrycontainer">
              <Masonry
                className="nw-brandlist-mobmasonry"
                data={brandObject}
                columnCount={columnCount}
                renderList={BrandListComponent.returnBrand}
                ref={context => {
                  this.masonryData = context;
                }}
              />
            </GridRow>
          </GridColumn>
          {!isDesktop ? (
            <GridColumn className="nwc-grid-col-xs nw-brandlist-keyscontainer">
              <BrandsListKeyContainer.component
                className="nw-brandslist-keywrapper"
                brandsListKeys={brandsListKeys}
                brandBlockFn={this.brandBlock}
              />
            </GridColumn>
          ) : null}
          <BannerComponent.component
            gridClassName="nw-brandslist-bannerslot"
            imgClassName="nw-brandslist-banner1"
            trendingBannerContainerClassName="nw-brandslist-trendingbannercontainer"
            trendingBannerSlotClassName="nw-trending-trendingbannerslot"
            trendingBannerImgClassName="nw-brandslist-trendingbanner"
            specialBannerContainerClassName="nw-brandslist-bannercontainer"
            specialBannerImgClassName="nw-brandslist-banner2"
            specialBannerButtonClassName="nw-brandslist-bannerbutton"
            trendingBannerObject={trendingBannerObject}
            bannerObject={bannerObject}
            showBanner={showBanner}
          />
        </GridRow>
      </GridContainer>
    );
  }
}

BrandListComponent.wrappedComponent.propTypes = {
  StaticPageStore: PropTypes.shape({
    brandBannerObject: PropTypes.shape({}).isRequired,
    trendingBannerObject: PropTypes.shape({}).isRequired,
    brandListFilter: PropTypes.shape({}).isRequired,
    brandListKeys: PropTypes.arrayOf().isRequired,
    filteredBrandList: PropTypes.arrayOf().isRequired,
    setFilterValue: PropTypes.func.isRequired,
    setSearchValue: PropTypes.func.isRequired,
  }).isRequired,
  isBrandJourney: PropTypes.bool.isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("StaticPageStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandListComponent.wrappedComponent,
  component: BrandListComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BrandsListComponent/index.js